import dayjs from "dayjs";
import { array, date, number, object, string } from "yup";

import { DiscountTypeEnum } from "@/features/shared";

export const DEFAULT_VALUES = {
  transactionDate: dayjs(),
  salesInvoiceProductVariants: [],
  salesInvoiceExpenses: [],
  salesDownPaymentAllocations: [],
  discount: 0,
  discountInput: 0,
  discountType: DiscountTypeEnum.FIXED_AMOUNT,
  taxable: false,
  totalIncludesTax: false,
  taxPercentage: 11,
  subtotal: 0,
};

export const VALIDATION_SCHEMA = object().shape({
  buyer: object().required("Harus diisi"),
  paymentTerm: object().required("Harus diisi"),
  transactionDate: date().required("Harus diisi"),
  // `discountInput` is the raw user entry: a percent (0-100) when the type is
  // percentage, otherwise a rupiah amount that cannot exceed the subtotal.
  discountInput: number()
    .transform((value, original) =>
      String(original).trim() === "" ? 0 : value
    )
    .min(0, "Diskon tidak boleh kurang dari 0")
    .when("discountType", {
      is: DiscountTypeEnum.PERCENTAGE,
      then: (schema) => schema.max(100, "Diskon persentase maksimal 100%"),
      otherwise: (schema) =>
        schema.test(
          "not-exceed-subtotal",
          "Diskon tidak boleh melebihi subtotal",
          function (value) {
            return (value || 0) <= (this.parent.subtotal || 0);
          }
        ),
    }),
  salesInvoiceProductVariants: array().min(
    1,
    "Harus memiliki setidaknya satu produk"
  ),
  salesInvoiceExpenses: array().of(
    object().shape({
      outletChartOfAccount: object().required("Harus diisi"),
      amount: number().min(0, "Tidak boleh negatif").required("Harus diisi"),
      note: string().nullable(),
    })
  ),
  salesDownPaymentAllocations: array().of(
    object().shape({
      sourceSalesInvoiceId: string().required("Harus diisi"),
      amount: number()
        .min(0, "Tidak boleh negatif")
        .test(
          "max-available",
          "Melebihi sisa tersedia",
          function (value) {
            return value == null || value <= this.parent.availableAmount;
          }
        )
        .required("Harus diisi"),
    })
  ),
});
